<template>
    <fieldset class="element-row">

        <label class="element-row_label">
            <span class="element-row_title">
                <template v-if="!bold"><span v-html="title" /></template>
                <strong v-else><span v-html="title" /></strong>
            </span>
            <span v-if="validation" class="element-row_info" :title="validation.msg" v-b-tooltip:fullscreen.hover.bottomright><div><base-icon name="info" /></div></span>
            <span v-if="!not_required" class="element-row_must">*</span>
        </label>

        <div class="element-row_fields">
            <div class="element-row_field">
                <b-form-input
                    ref="value_input" placeholder="Введите значение" size="sm"
                    type="number"
                    v-model="value" @change="(value) => set_value('value', value)"
                    :readonly="readonly"
                    :state="state" aria-describedby="value"
                    @input="validate" :formatter="formatter"
                />
                <b-form-invalid-feedback id="value" v-if="validation && validation.msg" tooltip>
                    {{ validation.msg }}<template v-if="!not_required">, обязательное значение</template>
                </b-form-invalid-feedback>
            </div>
    
            <element_with_source v-if="!without_source" :data="data" class="element-row_field" :disabled="readonly" v-on:set_source="value => set_value('source', value)" v-on:set_file="value => set_value('file', value)"/>
        </div>


    </fieldset>
</template>

<script>
import element_with_source from "./element"

export default {
    props :
    {
        title : String,
        data : Object,
        readonly : { type: Boolean, default : false },
        validation : { type: Object, default: null },
        without_source : { type : Boolean, default : false },
        not_required : { type : Boolean, default : false },
        bold : { type : Boolean, default : false }
    },

    components :
    {
        element_with_source
    },

    data()
    {
        return {
            state: null,
            value: null
        }
    },

    watch :
    {
        data :
        {
            handler()
            {
                if (this.data.value !== null && this.data.value !== undefined)
                {
                    this.value = this.data.value.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 30 })
                }
                else
                {
                    this.value = this.data.value
                }

                this.validate(this.value)
            },
            immediate: true
        }
    },

    methods :
    {
        formatter(value)
        {
            if (
                value === ""
                || this.validation === null
                || (this.validation.gt_min !== undefined && Number(value) === this.validation.gt_min)
                || (this.validation.lt_max !== undefined && Number(value) === this.validation.lt_max)
                || this.validation.check(value)
            )
            {
                return value
            }
            else
            {
                return this.value
            }
        },

        validate(value)
        {
            !this.validation || this.validation.check(value) || this.readonly ? this.state = null : this.state = false
        },
        
        set_value(key, value)
        {
            if (!this.readonly)
            {
                if (key === "value" && this.validation !== null)
                {
                    if (this.validation.check(value))
                    {
                        const _value = Number(value)
                        this.$emit("set_value", key, _value)
                    }
                    else
                    {
                        this.value = this.data.value.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 30 })
                        this.validate(this.value)
                    }
                }
                else
                {
                    this.$emit("set_value", key, value)
                }
            }
        }
    }
}
</script>

<style>
.element-row
{
    margin-top: .5rem;
    width: 100%;
    display: flex;
    gap: 1rem;
}

.element-row_label
{
    width: 50%;
    display: flex;
    justify-content: end;
    text-align: end;
    gap: .25rem;
    margin: 0;
}

.element-row_title
{
    display: flex;
    align-items: center;
}

.element-row_info
{
    color: var(--bft-neatural-900);
    width: .75rem;
}

.element-row_info div
{
    position: relative;
    right: 50%;
    top: .8px;
}

.element-row_info svg
{
    vertical-align: unset;
    transform: scale(.6);
}

.element-row_must
{
    color: var(--bft-red-500);
}

.element-row_fields
{
    --element-row_fields-gap: 8px;
    width: 50%;
    display: flex;
    gap: var(--element-row_fields-gap);
}

.element-row_field
{
    width: calc(50% - (var(--element-row_fields-gap) / 2));
    position: relative;
}

.element-row_field .invalid-tooltip
{
    display: none;
    top: 1.625rem;
    left: unset;
    right: .5rem;
    background-color: var(--bft-neutral-900-tooltip);
    max-width: max-content;
}

.element-row_field .form-control.is-invalid:hover + .invalid-tooltip
{
    display: block;
}
</style>
